import type { Theme } from '@ori-ui/mui';
import { useTheme } from '@ori-ui/mui';
import { useMemo } from 'react';

import { useTopAreaStore } from '../stores/TopAreaStore';

const get = (type: string, palette: Theme['palette']) => {
  switch (type) {
    case 'BrandsPage':
    case 'FavoritesListing':
    case 'FocusPage':
      return {
        backgroundColor: palette.secondary.main,
        color: palette.common.white,
      };
    case 'IngredientsListingPage':
      return {
        backgroundColor: palette.primary.light,
        color: palette.common.white,
      };
    default:
      return undefined;
  }
};

export const usePageTypeColors = () => {
  const { pageType } = useTopAreaStore();
  const { palette } = useTheme();

  return useMemo(() => get(pageType, palette), [pageType, palette]);
};
